import loginLinkListener from './modules/loginLinkListener';
import submitUserInfoToEtracker from './modules/tracking';
import {trackLoginEvent, trackRegisterEvent} from './modules/checkoutTracking';
import verifyPlenigoUser from './modules/verifyUser';

window.addEventListener('load', verifyPlenigoUser);
window.addEventListener('load', loginLinkListener());
window.addEventListener('load', submitUserInfoToEtracker());
document.addEventListener('plenigo.defaultStepSuccessRegister', trackLoginEvent);
document.addEventListener('plenigo.defaultStepSuccessLogin', trackRegisterEvent);
